module.exports = __webpack_public_path__ + "assets/img/35@3x.00a13725.png";